import React, { useEffect, useState, useContext, useRef } from "react";
import styled from "styled-components";
import './streamchat.sass'
import _ from 'lodash'
import moment from 'moment'
import Icon from '@material-ui/core/Icon';
import { DashboardContext } from '../../dashboard-context'
import { ThemeContext } from 'styled-components'
import {
  Channel,
  ChannelList,
  MessageList,
  MessageInput,
  Thread,
  Window,
  useChatContext
} from "stream-chat-react";
import config from '../../../../config'
import { AuthContext } from "../../../../auth-context";
import { ReactComponent as CurvedLine } from '../../../../images/screen-separator.svg';
import Tooltip from '@material-ui/core/Tooltip';
import { withStyles } from '@material-ui/core/styles';
import { getOrCreatePortalChannel, checkGroupLinks } from "../../../../api";
import { useHistory } from "react-router-dom";
import { Toggle } from '../../views/overview/components/toggle'
import Div100vh from 'react-div-100vh'
import { CustomAttachment } from "./custom-attachment"

const Header = styled.div`
  background: ${props => props.theme.chat.headerBackground};
  padding-bottom: ${props => props.messageChannel ? '12px' : '50px'};
  position: ${props => props.messageChannel ? 'absolute' : 'relative'};
  top: 0;
  left: 0;
  z-index: 3;
  width: 100%;

  h2 {
    color: #FFF;
    font-size: 2rem;
    font-weight: 600;
    padding: 36px 24px 0px 24px;
  }

  p {
    color: #FFF;
    margin: 12px 0 24px 24px;
  }

  svg {
    position: absolute;
    bottom: 0;
    left: 0;
  }
`;

const BackButton = styled.button`
  background: none;
  border: none;
  color: #FFF;
  cursor: pointer;
  font-family: 'DM Sans', sans-serif;
  display: flex;
  align-items: center;
  font-size: 1.25rem;
  font-weight: 600;
  padding: ${props => props.messageChannel ? '12px 0px 0px 24px' : '24px 0px 0px 24px'};
  span {
    margin-right: 3px;
  }
`;

const NewChannel = styled.button`
  background: none;
  border: 2px solid #FFF;
  border-radius: 100px;
  cursor: pointer;
  display: block;
  font-family: 'DM Sans', sans-serif;
  margin: 12px 0 0 24px;
  color: #FFF;
  font-size: 1rem;
  font-weight: 500;
  letter-spacing: 0px;
  padding: 10px 24px;
  text-transform: none;
  transition: 0.3s ease all;
  &:hover {
    opacity: 0.6;
  }
`

const Popout = styled(Div100vh)`
  /* background: linear-gradient(#070d2c 30%, #06010d); */
  background: #fff;
  box-shadow: 0px 0px 30px 0px #0000004f;
  height: 100%;
  overflow: auto;
  position: fixed;
  top: 0;
  right: 0;
  transition: 0.4s ease all;
  transform: translateX(${props => props.show ? '0%': '100%'});
  width: 100%;
  max-width: 820px;
  z-index: ${props => props.zIndex ? props.zIndex: 600};
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
`;

const Options = styled.div`
  display: flex;
  flex-direction: column;
  padding: 16px;
`;

const Input = styled.input`
  background: #eaedf5;
  border: none;
  border: 1px solid #DDDEE8;
  border-radius: 100px;
  font-family: "DM Sans", sans-serif;
  font-size: 1rem;
  padding: 12px;
  margin: 20px 0px;
  transition: 0.2s ease border, 0.2s ease box-shadow;
  &:focus {
    border: 1px solid #0ab23b;
    box-shadow: 0px 0px 0px 3px #acec9ca6;
    outline: none;
  }
`;

// const TabContainer = styled.div`
//   background: #dcdee6;
//   border-radius: 8px;
//   display: inline-block;
//   align-self: center;
//   margin-bottom: 6px;
// `;

// const CustomTab = styled.div`
//   background: ${(props) => (props.active ? "#10132b" : "none")};
//   border: none;
//   border-radius: 8px;
//   color: ${(props) => (props.active ? "#FFF" : "#464646")};
//   cursor: pointer;
//   display: inline-block;
//   font-weight: 700;
//   padding: 4px 18px;
//   text-align: center;
//   text-transform: none; 
//   width: 140px;
// `;

const ResultList = styled.div`
  padding: 8px;
  max-height: 660px;
  overflow: auto;
`;

const ResultItem = styled.div`
  box-shadow: 0px 0px 8px 0px #e1e2e6;
  border-radius: 8px;
  display: flex;
  justify-content: space-between;
  margin: 8px 0px;
  padding: 16px 16px 16px 12px;
  p {
    font-size: 1.125rem;
    font-weight: 500;
    display: flex;
    align-items: center;
  }
  button {
    background: none;
    border: none;
    cursor: pointer;
    display: flex;
    align-items: center;

    /* Group styling, hide for now */
    /* background: ${props => props.added ? 'linear-gradient(#00eb45,#0ea039)' : '#FFF'};
    border: none;
    border-radius: 100px;
    box-shadow: 0px 1px 6px rgba(0, 0, 0, 0.25);
    color: ${props => props.added ? '#FFF' : 'inherited'};
    cursor: pointer;
    font-family: 'DM Sans', sans-serif;
    font-size: .75rem;
    font-weight: 600;
    padding: 2px 16px;
    width: 72px; */

    span {
      font-family: 'Material Icons'
    }
  }
`;

const CustomList = styled.div`
  background: #FFF;
  padding: 0px 10px;
`;

const ListItem = styled.div`
  background: #FFF;
  border-radius: 16px;
  box-shadow: rgba(137, 156, 197, 0.2) 0px 0px 12px;
  cursor: pointer;
  display: flex;
  align-items: center;
  margin: 10px 0px;
  transition: 0.2s ease all;
  padding: 10px 12px;
  position: relative;
  width: 100%;

  &:hover {
    background: #fcfcfc;
    opacity: 0.8;
  }

  img {
    align-self: flex-start;
    flex-shrink: 0;
    object-fit: cover;
    border-radius: 100px;
    width: 48px;
    height: 48px;
    margin-right: 12px;
  }

  .alert {
    background: red;
    border-radius: 100px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    height: 16px;
    width: 16px;
    top: 4px;
    left: 4px;

    p {
      color: #FFF;
      font-size: .7rem;
      font-weight: bold;
    }
  }

  .text {
    width: 100%;
    .title-row {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 8px;
      width: 100%;
    }
    p {
      color: #333;
      font-family: 'DM Sans', sans-serif;
      font-size: .9rem;
      font-weight: bold;
    }
    .tags {
      font-weight: 400;
      span {
        display: inline;
        font-size: .7rem;
        font-weight: 400;
      }
      .tag {
        background: #eaedf5;
        border-radius: 4px;
        margin: 0 2px;
        padding: 0px 4px;
        &.group {
          background: #eaedf5;
        }
      }
    }
    .shared {
      color: #f42b2b;
      font-size: .8rem;
      font-weight: 400;
    }

    .timestamp {
      color: #666;
      display: inline-block;
      font-family: 'DM Sans', sans-serif;
      font-size: .8rem;
      font-weight: 400;
      flex-shrink: 0;
      margin-left: 8px;
      white-space: nowrap;
      width: auto;
      max-width: none;
      overflow: visible;
      text-overflow: unset;
    }

    span {
      color: #3c3c3c;
      display: block;
      font-family: 'DM Sans', sans-serif;
      font-size: .9rem;
      width: 100%;
      max-width: 90%;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;

      @media(max-width: 400px) {
        width: 100%;
        max-width: 220px;
      }
    }
  }
`;

const EmptyChat = styled.div`
  margin-top: 120px;

  span {
    color: #070b28;
    display: block;
    margin: 0 auto;
    font-family: 'Material Icons';
    font-size: 4rem;
    text-align: center;
    margin-bottom: 24px;
  }
  h4 {
    font-family: 'DM Sans', sans-serif;
    font-size: 1.5rem;
    text-align: center;
  }
`;

const AvatarPlaceholder = styled.div`
  align-self: flex-start;
  background: ${(props) => props.theme.color.primary};
  border-radius: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  margin-right: 12px;
  height: 48px;
  width: 48px;

  span {
    color: #FFF;
    font-family: 'DM Sans', sans-serif;
    font-size: 1.5rem;
    font-weight: 500;
  }
`;

const CustomDarkTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: '#08091f',
    color: '#FFFFFF',
    borderRadius: '12px',
    boxShadow: theme.shadows[1],
    fontFamily: 'DM Sans',
    fontSize: 12,
  },
  arrow: {
    color: '#08091f'
  }
}))(Tooltip);

const TipContent = styled.div`
  display: flex;
  flex-direction: column;
  padding: 6px;
  p {
    font-size: .9rem;
    font-weight: normal;
    display: flex;
    align-items: center;
    margin-bottom: 4px;
  }
  li {
    font-size: .9rem;
    font-weight: normal;
    margin-bottom: 4px;
    span {
      font-weight: bold;
    }
  }
  span {
    font-size: .9rem;
    font-weight: normal;
    text-align: center;
    margin-bottom: 4px;
  }
`;

const ViewingTrainer = styled.div`
  border-radius: ${props => props.theme.button.borderRadius};
  display: flex;
  align-items: center;
  justify-content: center;
  align-self: flex-start;
  margin-top: 16px;
  p {
    font-size: .9rem;
    /* color: #FFF; */
    font-weight: 500;
    text-align: center;
    padding: 4px;
  }

  button {
    background: none;
    border: none;
    color: #f42b2b;
    cursor: pointer;
    font-weight: 500;
    margin-left: 12px;
  }
`;

const DarkTooltip = ({children, title, placement}) => (
  <CustomDarkTooltip
    arrow
    enterDelay={200}
    title={title}
    placement={placement}
  >
    {children}
  </CustomDarkTooltip>
)

export const ChatService = () => {
  const { user } = useContext(AuthContext);
  const { client, setActiveChannel } = useChatContext();
  const { showMessages, setShowMessages, messageChannel, setMessageChannel, channelFilter, setChannelFilter} = useContext(DashboardContext);
  const theme = useContext(ThemeContext)
  const [userSearch, setUserSearch] = useState("");
  const [channelSearch, setChannelSearch] = useState("");
  const [tab, setTab] = useState("clients");
  const [showCreate, setShowCreate] = useState(false);
  const [selectedUsers, setSelectedUsers] = useState([
    `${config.STREAMCHAT.portalUserPrefix}${user.id}`,
  ]);
  const [createdStreamUsers, setCreatedStreamUsers] = useState([]);
  const [showMyChannel, setShowMyChannel] = useState(false);

  useEffect(() => {
    getCreatedStreamUsers();
    const interval = setInterval(() => {
      getCreatedStreamUsers();
    }, 60000);
    return () => clearInterval(interval);
  }, []);

  const getCreatedStreamUsers = () => {
    const searchResult = _.cloneDeep(user.accounts).filter(
      (entry) =>
        entry.claimed === 1 &&
        ((user.role_id === 3 || showMyChannel) ? entry.trainers.includes(user.id) : true)
    );
    let userStreamIds = [];
    const createdStreamUsers = [];
    searchResult.forEach((entry) => {
      const userID = tab === "team" ? entry.id : entry.user_id;
      const chatID =
        tab === "team"
          ? `${config.STREAMCHAT.portalUserPrefix}${userID}`
          : `${config.STREAMCHAT.userPrefix}${userID}`;
      userStreamIds.push(chatID);
    });
    userStreamIds = _.chunk(userStreamIds, 100);

    const fetchData = async () => {
      await Promise.all(
        userStreamIds.map(async (streamIds) => {
          return await client.queryUsers(
            { id: { $in: streamIds } },
            { last_active: -1 },
            { presence: false, limit: 100 }
          );
        })
      ).then((response) => {
        response.forEach((res) => {
          if (res.users.length > 0) {
            res.users.forEach((data) => {
              createdStreamUsers.push(data.id);
            });
          }
        });
      });
      setCreatedStreamUsers(createdStreamUsers);
    };
    fetchData();
  }

  const createChannel = async (clientID, assignedTrainers) => {
    const getId = await getOrCreatePortalChannel(user.id, clientID)
    const channelId = getId?.data?.result?.channel_id
    if(channelId) {
      const filter = { id: channelId };
      const sort = { last_message_at: -1 };
      const options = { watch: true, state: true }
      const getChannel = await client.queryChannels(filter, sort, options);

      setActiveChannel(getChannel[0]);
      setMessageChannel(getChannel[0]);  
      setShowCreate(false)
      setSelectedUsers([`${config.STREAMCHAT.portalUserPrefix}${user.id}`])
    }
  }

  let filters = {
    type: "portal",
    portal_owner: `${config.STREAMCHAT.portalUserPrefix}${user.owner_id}`
  };
  let options = { state: true, watch: true, presence: true, limit: 30 };

  const assignedUsers = _.cloneDeep(user.accounts)
    .filter(client => 
      (
        client.claimed === 1 &&
        !!client.user_id &&
        ((user.role_id === 3 || showMyChannel) ? client.trainers.includes(user.id) : true)
      )
    )
    .map(client => {
      return `${config.STREAMCHAT.userPrefix}${client.user_id}`
    });

  if (user.role_id === 3 || showMyChannel) {
    filters['members'] = { $in: (assignedUsers.length > 0) ? assignedUsers : ['none'] }
  }

  if (channelFilter) {
    filters = channelFilter.filter
    options = { state: true, watch: true, presence: true, limit: 30 };
  }
  const sort = { last_message_at: -1 };

  let searchResult
  if (tab === 'team') {
    searchResult = _.cloneDeep(user.team).filter(client => client.name.toLowerCase().includes(userSearch.toLowerCase()))
  } else {  
    searchResult = _.cloneDeep(user.accounts).filter(client => 
      (
        client.name.toLowerCase().includes(userSearch.toLowerCase()) &&
        // client.trainer_permission &&
        client.claimed === 1 &&
        ((user.role_id === 3 || showMyChannel) ? client.trainers.includes(user.id) : true)
      )
    )
  }

  if (!client) return null;
  return (
    <>
      <Popout show={showMessages}>
        {messageChannel ? (
          <Header messageChannel>
            <BackButton messageChannel onClick={() => setMessageChannel("")}>
              <Icon>chevron_left</Icon>Back
            </BackButton>
          </Header>
        ) : (
          <Header>
            <BackButton
              onClick={() => {
                setShowMessages(false);
                setMessageChannel("");
                setChannelFilter("");
              }}
            >
              <Icon>chevron_left</Icon>Close
            </BackButton>
            <h2>Messaging</h2>
            <p>Chat with your clients</p>
            <NewChannel onClick={() => setShowCreate(true)}>
              Create chat
            </NewChannel>
            {theme.name === "AVATAR" && <CurvedLine />}
          </Header>
        )}
        {channelFilter && !messageChannel && (
          <ViewingTrainer>
            <p>Viewing {channelFilter.trainerName}'s message channels</p>
            <button onClick={() => setChannelFilter("")}>Clear filter</button>
          </ViewingTrainer>
        )}
        {messageChannel ? (
          <Channel 
            Attachment={CustomAttachment}
          >
            <Window>
              <MessageList />
              {!channelFilter && <MessageInput maxRows={12} />}
            </Window>
            <Thread />
          </Channel>
        ) : (
          <Content>
            <Options>
              <Input
                placeholder="Search channels"
                onChange={(e) => setChannelSearch(e.target.value)}
                value={channelSearch}
              />
              {(user.role_id === 1 || user.role_id === 2) &&
                <Toggle
                  label="Show only my assigned clients"
                  note="Only assigned clients will have persistent notification badges"
                  checked={showMyChannel}
                  onChange={() => setShowMyChannel(!showMyChannel)}
                />
              }
            </Options>
            <ChannelList
              filters={filters}
              sort={sort}
              options={options}
              List={CustomListContainer}
              Preview={(props) => (
                <CustomListItem
                  {...props}
                  key={props.channel.id}
                  accounts={user.accounts}
                  chatID={`${config.STREAMCHAT.portalUserPrefix}${user.id}`}
                  userID={user.id}
                  ownerID={user.owner_id}
                  channelSearch={channelSearch}
                  filter={channelFilter?.trainerName}
                  open={!!!messageChannel && !showCreate}
                />
              )}
            />
          </Content>
        )}
      </Popout>

      <Popout show={showCreate} zIndex={650}>
        <Header>
          <BackButton
            onClick={() => {
              setShowCreate(false);
              setSelectedUsers([
                `${config.STREAMCHAT.portalUserPrefix}${user.id}`,
              ]);
            }}
          >
            <Icon>chevron_left</Icon>Back
          </BackButton>
          <h2>New Chat</h2>
          <CurvedLine />
        </Header>
        <Content>
          <Input
            placeholder="Search user"
            onChange={(e) => setUserSearch(e.target.value)}
            value={userSearch}
          />
          {/* <TabContainer>
            <CustomTab
              active={tab === 'team'}
              onClick={() => setTab("team")}
            >
              Team
            </CustomTab>
            <CustomTab
              active={tab === 'clients'}
              onClick={() => setTab("clients")}
            >
              Clients
            </CustomTab>
          </TabContainer> */}
          <ResultList>
            {searchResult.map((entry, index) => {
              const userID = tab === "team" ? entry.id : entry.user_id;
              const chatID =
                tab === "team"
                  ? `${config.STREAMCHAT.portalUserPrefix}${userID}`
                  : `${config.STREAMCHAT.userPrefix}${userID}`;
              const added = selectedUsers.includes(chatID);

              if (!!userID) {
                return (
                  <ResultItem added={added} key={userID}>
                    <p>{entry.name}</p>
                    {(createdStreamUsers.includes(chatID) && !entry.linked_portal_id) ? (
                      <button
                        onClick={() => createChannel(userID, entry.trainers)}
                      >
                        <Icon>message</Icon>
                      </button>
                    ) : (
                      <DarkTooltip
                        arrow
                        title={
                          <TipContent>
                            <p>
                              {entry.linked_portal_id ? `This user is a coach account for ${entry.linked_portal_name}.` : 'This user must sign in again before messaging is available.'}
                            </p>
                          </TipContent>
                        }
                        key={chatID}
                      >
                        <button onClick={() => null} style={{ opacity: 0.2 }}>
                          <Icon>message</Icon>
                        </button>
                      </DarkTooltip>
                    )}
                    {/* <button onClick={() => added ? removeUser(chatID) : addUser(chatID)}>
                      {added ? 'Added' : 'Add'}
                    </button> */}
                  </ResultItem>
                );
              }
            })}
          </ResultList>
          {/* <CreateButton onClick={createChannel}>
            Create chat
          </CreateButton> */}
        </Content>
      </Popout>
    </>
  );
};


const CustomListContainer = (props) => {
  if (props.children.props.children) {
    return (
      <CustomList>
        {props.children}
      </CustomList>
    )
  } else {
    return(
      <EmptyChat>
        <Icon>message</Icon>
        <h4>No chats found</h4>
      </EmptyChat>
    )
  }
};

const CustomListItem = (props) => {
  const { setMessageChannel } = useContext(DashboardContext);
  const { user } = useContext(AuthContext);
  const isMounted = useRef(false)
  const [show, setShow] = useState(!props.filter)
  const history = useHistory();

  useEffect(() => {
    isMounted.current = true;
    return () => { isMounted.current = false }
  }, []);

  useEffect(() => {
    // Note: ChanneList re-renders often, so props.open minimizes checkGroupLink calls. This tends to remount on parent state changes.
    if (props.filter && props.open) {
      const channelMembers = Object.keys(props.channel.state.members)
      const getHasLink = async () => {
        await checkGroupLinks(props.userID, channelMembers).then((res) => {
          const result = res.data.result
          let ownerMatch = false
          if (result.linked_managers) {
            result.linked_managers.forEach(entry => {
              if (entry.manager_id === props.ownerID) {
                ownerMatch = true
              }
            })
          }

          if(result.hasLink && (props.channel.data.owner || props.channel.data.portal_owner) && ownerMatch && isMounted.current) {
            setShow(true)
          }
        })
      }

      getHasLink()
    }
  }, [props.filter, props.open]);
  
  const members = Object.entries(props.channel.state.members)
  let clientDisplay = ''
  let clientImg = ''
  let trainerDisplay = []
  let groupDisplay = []
  let searchShow = !props.channelSearch
  let clientID
  let accountID

  //haslink and channel has owner
  members.forEach(entry => {
    const name = entry[1].user.name
    if (!clientID && !props.filter) {
      if (entry[1].user.avatar_id) {
        clientID = entry[1].user.avatar_id
      } else if (!entry[1].user.id.includes(config.STREAMCHAT.portalUserPrefix)) {
        clientID = Number(entry[1].user.id.replace(config.STREAMCHAT.userPrefix, ''))
      }
    }
    if(entry[1].user.role === 'user') {
      clientDisplay = name
      clientImg = entry[1].user.image
    } else if (entry[1].user.role === 'portal_trainer') {
      trainerDisplay.push(<span className="tag" key={name}>{name}</span>)
    }
    if (props.channelSearch && entry[1].user.name.toLowerCase().includes(props.channelSearch.toLowerCase()))
      searchShow = true
  })

  //Get account ID for inspect profile
  if (clientID) {
    const userProfile = props.accounts.find(u => u.user_id === clientID)
    if (userProfile) {
      accountID = userProfile.id
      const groupData = user.groups.filter((g) => userProfile.groups.includes(g.id))
      groupData.forEach((data) => {
        groupDisplay.push(<span className="tag group" key={data.name}>{data.name}</span>)
      })
    }
  }

  const previewText = props.lastMessage?.text ? props.lastMessage.text : props.lastMessage?.attachments?.length > 0 ? `🏙 ${props.lastMessage.user.name} sent a file...` : '';
  const lastMessageTimestamp = props.lastMessage?.created_at || props.lastMessage?.createdAt || props.channel?.state?.last_message_at || props.channel?.data?.last_message_at
  const formattedLastMessageTimestamp = (() => {
    if (!lastMessageTimestamp) {
      return ''
    }

    const ts = moment(lastMessageTimestamp)
    if (!ts.isValid()) {
      return ''
    }

    if (ts.isSame(moment(), 'day')) {
      return `Today ${ts.format('h:mm A')}`
    }

    if (ts.isSame(moment().subtract(1, 'day'), 'day')) {
      return `Yesterday ${ts.format('h:mm A')}`
    }

    return ts.format('MMM Do, h:mm A')
  })()

  if (!show || !searchShow) return null
  return (
    <ListItem key={props.channel.id}>
      {clientImg ?
        <img 
          onClick={() => { if (accountID) history.push(`/dashboard/inspect/${accountID}/overview`)}}
          src={clientImg} 
          alt="thumbnail"  
        />
      :
        <AvatarPlaceholder onClick={() => { if (accountID) history.push(`/dashboard/inspect/${accountID}/overview`)}}>
          {clientDisplay && <span>{clientDisplay.charAt(0)}</span>}
        </AvatarPlaceholder>
      }
      <div className="text" onClick={() => { props.setActiveChannel(props.channel); setMessageChannel(props.channel);}}>
        <div className="title-row">
          <p>{clientDisplay}</p>
          {formattedLastMessageTimestamp && <span className="timestamp">{formattedLastMessageTimestamp}</span>}
        </div>
        {trainerDisplay.length > 0 &&
          <p className="tags"><span>Trainers: </span> {trainerDisplay}</p>
        }
        {groupDisplay.length > 0 && 
          <p className="tags"><span>Groups:</span> {groupDisplay}</p>
        }  
        {/* {props.channel.type === 'portal' && <p className="shared">Shared trainer channel</p>} */}
        <span>{previewText}</span>
      </div>
      {(!!props.channel?.state?.unreadCount) && 
      <div className="alert">
        <p>{props.channel.state.unreadCount}</p>
      </div>}
    </ListItem>
  )
};
